import React, { forwardRef, useImperativeHandle, useState, useCallback, useEffect } from 'react';
import DeleteIcon from '../../static/image/deleteIcon.svg';
import CustomInput from '../../components/customInput/CustomInput';
import CommonDeleteModal from '../../components/commonDeleteModal/CommonDeleteModal';
import CommonCKEditor from '../../components/commonCKEditor/CommonCKEditor';

import { useDispatch } from 'react-redux';

import { fetchIndustryContent } from '../../redux/homePageSlice';

const FAQ = forwardRef(({ language, faqData }, ref) => {
  const dispatch = useDispatch();
  const [faqTitle, setFaqTitle] = useState('');
  const [faqItems, setFaqItems] = useState([
    {
      question: '',
      answer: ''
    }
  ]);

  const [showDeleteFaqModal, setShowDeleteFaqModal] = useState(false);
  const [faqToDelete, setFaqToDelete] = useState(null);

  const PLACEHOLDER_CONFIG = {
    title: {
      EN: "Enter FAQ title EN",
      CN: "Enter FAQ title CN"
    },
    question: {
      EN: "Enter question EN",
      CN: "Enter question CN"
    },
    answer: {
      EN: "Enter answer EN",
      CN: "Enter answer CN"
    }
  };

  useEffect(() => {
    if (language) {
      dispatch(fetchIndustryContent({
        language,
        page: 'faq',
        region: 'SG',
        type: 'homePage'
      }))
        .then((result) => {
          if (result.payload) {
            const contentData = result.payload.resdata?.contentData;

            if (contentData) {
              setFaqTitle(contentData.title || '');
              if (contentData.items && contentData.items.length > 0) {
                setFaqItems(contentData.items);
              } else {
                setFaqItems([{ question: '', answer: '' }]);
              }
            }
          }
        })
        .catch((error) => {
          console.error('Failed to fetch FAQ data:', error);
        });
    }
  }, [language, dispatch]);

  useEffect(() => {
    if (faqData) {
      setFaqTitle(faqData.title || '');
      if (faqData.items && faqData.items.length > 0) {
        setFaqItems(faqData.items);
      } else {
        setFaqItems([
          {
            question: '',
            answer: ''
          }
        ]);
      }
    }
  }, [faqData]);

  const addGroup = useCallback(() => {
    setFaqItems(prevItems => [
      ...prevItems,
      {
        question: '',
        answer: ''
      }
    ]);
  }, []);

  const deleteGroup = useCallback((index) => {
    if (faqItems.length <= 1) {
      alert("At least retain one FAQ item EN");
      return;
    }
    setFaqToDelete(index);
    setShowDeleteFaqModal(true);
  }, [faqItems, language]);

  const handleConfirmDeleteFaq = useCallback(() => {
    if (faqToDelete !== null) {
      setFaqItems(prevItems => prevItems.filter((_, i) => i !== faqToDelete));
    }
    setShowDeleteFaqModal(false);
    setFaqToDelete(null);
  }, [faqToDelete]);

  const updateFaq = useCallback((field, value) => {
    if (field === 'title') {
      setFaqTitle(value);
    }
  }, []);

  const updateFaqItem = useCallback((index, field, value) => {
    setFaqItems(prevItems =>
      prevItems.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  }, []);

  const validateAllFaqs = useCallback(() => {
    return {};
  }, []);

  useImperativeHandle(ref, () => ({
    addGroup,
    validateAllFaqs,
    getData: () => ({
      title: faqTitle,
      items: faqItems
    })
  }));


  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
    });

    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div className="tab-package-container">
      <div className="domain-group">
        <div className='package-input'>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <label>Title:</label>
          </div>
          <CustomInput
            type="text"
            value={faqTitle}
            onChange={(e) => updateFaq('title', e.target.value)}
            placeholder={PLACEHOLDER_CONFIG.title[language]}
            customStyle={{ width: '73%' }}
          />
        </div>
      </div>

      <div
        style={{
          height: '0.5px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          margin: '25px -40px',
          width: 'calc(100% + 80px)',
          display: 'block',
          boxSizing: 'border-box'
        }}
      />

      {faqItems.map((faq, index) => (
        <div key={index}>
          <div className="domain-group">
            <div className='package-input'>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <label>Question:</label>
              </div>
              <CustomInput
                type="text"
                value={faq.question || ''}
                onChange={(e) => updateFaqItem(index, 'question', e.target.value)}
                placeholder={PLACEHOLDER_CONFIG.question[language]}
                customStyle={{ width: '73%' }}
              />
              <button
                className="icon-btn"
                onClick={() => deleteGroup(index)}
              >
                <img src={DeleteIcon} alt="Delete" className="campaign-delete-icon" />
              </button>
            </div>

            <div className='package-input'>
              <label>Answer:</label>
              <div style={{ width: '73%' }}>
                <CommonCKEditor
                  data={faq.answer || ''}
                  initialValue={faq.answer || ''}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    updateFaqItem(index, 'answer', data);
                  }}

                />
              </div>
            </div>
          </div>

          {index !== faqItems.length - 1 && (
            <div
              style={{
                height: '0.5px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                margin: '25px -40px',
                width: 'calc(100% + 80px)',
                display: 'block',
                boxSizing: 'border-box'
              }}
            />
          )}
        </div>
      ))}

      <CommonDeleteModal
        show={showDeleteFaqModal}
        onHide={() => {
          setShowDeleteFaqModal(false);
          setFaqToDelete(null);
        }}
        onConfirm={handleConfirmDeleteFaq}
        title="Delete FAQ"
        instruction="Are you sure you want to delete this FAQ item?"
      />
    </div>
  );
});

export default FAQ;